import { colors } from "@theme/colors"

const LinedFolderIcon = ({
  color = colors.iconPrimary,
  height = 18,
  width = 18,
}: {
  color?: string
  height?: number
  width?: number
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99477 4.29921L7.99462 4.29909L7.56944 3.94166L7.5693 3.94154C7.33378 3.7443 7.1195 3.60698 6.87177 3.52026C6.62463 3.43375 6.35098 3.4 6 3.4H3.92314C3.29439 3.4 2.78366 3.58107 2.43119 3.95888C2.07977 4.33556 1.9 4.89255 1.9 5.61526V14.3286C1.9 15.0694 2.08881 15.6423 2.48017 16.0292C2.87132 16.4158 3.44802 16.6 4.18806 16.6H16.0278C16.671 16.6 17.1938 16.4117 17.5549 16.0236C17.9148 15.6365 18.1 15.0657 18.1 14.3286V6.95292C18.1 6.21587 17.913 5.64488 17.5234 5.25893C17.134 4.87315 16.559 4.68894 15.8188 4.68894H9.03843C8.81015 4.68894 8.63296 4.66027 8.47299 4.59915C8.31272 4.53792 8.16383 4.44188 7.99477 4.29921ZM6.74293 5.12359L6.7429 5.12362L6.74486 5.12523L7.16954 5.47506C7.16963 5.47513 7.16971 5.47521 7.1698 5.47528C7.40195 5.66905 7.61779 5.8061 7.8677 5.89356C8.11715 5.98086 8.39412 6.01651 8.74556 6.01651H15.798C16.1256 6.01651 16.3666 6.10443 16.526 6.26387C16.6854 6.42328 16.7782 6.66917 16.7782 7.01628V7.33646H3.22183V5.67145C3.22183 5.34182 3.30939 5.11019 3.45978 4.96054C3.61027 4.81079 3.83902 4.72786 4.15327 4.72786H5.71427C5.93588 4.72786 6.1075 4.75476 6.26436 4.81554C6.42158 4.87646 6.57028 4.97386 6.74293 5.12359ZM4.20888 15.2721C3.87755 15.2721 3.63483 15.1841 3.47467 15.0246C3.31459 14.8652 3.22183 14.6195 3.22183 14.2724V8.59439H16.7782V14.2801C16.7782 14.6232 16.6856 14.8673 16.5262 15.026C16.3667 15.1847 16.1256 15.2727 15.798 15.2727L4.20888 15.2721Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  )
}

export default LinedFolderIcon
